// extracted by mini-css-extract-plugin
module.exports = {"checkbox-component":"Checkbox_checkbox-component__hbtM_"};